module.exports = __webpack_public_path__ + "img/2.4500eec9.webp";